import http from "../http";

export const getDashboardInfo = ({ schoolId }: { schoolId: number }) => {
  return http(`api/schools/${schoolId}/dashboard`, {
    method: "GET"
  });
};

export const getSchoolActivityFeed = ({
  schoolId,
  groupId,
  limit = 10,
  offset = 0
}: {
  schoolId: number;
  groupId?: number;
  limit?: number;
  offset?: number;
}) => {
  return http(`api/schools/${schoolId}/ActivityFeed`, {
    method: "GET",
    params: { groupId, limit, offset }
  });
};
